import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map, flatMap, switchMap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
// import { UserService } from '../../services/userService/user.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  tokenrefreshCalled = false;
  private onLoginStateChange: any[] = [];

  constructor(private http: HttpClient,
    private jwtHelper: JwtHelperService,
    private storageService: StorageService,
    private router: Router,
  ) { }

  public get(url: string, body?: Object): Observable<any> {
    return this.refresh().pipe(switchMap(res => {
      return this.http.get(url, { params: <HttpParams>body });
    }));
  }
  public post(url: string, body?: Object, headers?: any): Observable<any> {
    return this.refresh().pipe(switchMap(res => {
      return this.http.post(url, body, headers);
    }));
  }
  public put(url: string, body: Object = {}): Observable<any> {
    return this.refresh().pipe(switchMap(res => {
      return this.http.put(url, body);
    }));
  }
  public delete(url: string, body?: Object): Observable<any> {
    return this.refresh().pipe(switchMap(res => {
      return this.http.delete(url, { params: <HttpParams>body });
    }));
  }
  public patch(url: string, body?: Object): Observable<any> {
    return this.refresh().pipe(switchMap(res => {
      return this.http.patch(url, body);
    }));
  }
  public getHeaders(url, body): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('data', body);
    return this.http.get(url, { headers: headers });
  }

  runOnUserLoginChange(fn: any) {
    if (typeof fn === 'function') {
      this.onLoginStateChange.push(fn);
    }
  }

  onUserLoginStateChange() {
    for (const fn of this.onLoginStateChange) {
      if (typeof fn === 'function') {
        fn();
      }
    }
  }


  refresh(): Observable<any> {
    const token = localStorage.getItem('access_token');
    if (token && this.jwtHelper.isTokenExpired(token) && !this.tokenrefreshCalled) {
      this.tokenrefreshCalled = true;
      return this.http.post(environment.base_url + '/refresh', null)
        .pipe(map((res: Response) => {
          const element: any = res;
          this.storageService.setData('access_token', element.access_token);
          return of(true);
        }, err => {
          this.storageService.removeData('access_token');
          this.router.navigate(['/login']);
          this.onUserLoginStateChange();
        }));
    } else {
      this.tokenrefreshCalled = false;
      return of(true);
    }
  }
}
